<template>
  <VuePerfectScrollbar class="bbe-new-message" ref="bbeNewMailScroll">
    <transition name="bbe-fade" appear>
      <loader-fly v-if="loaderRun" :fill="true"/>
    </transition>
    <div class="bbe-new-message-header">
      <i class="email-icon-resize-mini bbe-new-message-header__resize" @click="openPopupMessage"/>
      <div class="bbe-new-message-header-details">
        <div class="bbe-label bbe-new-message-header-details-label">
          <label class="bbe-new-message-header-details-destination__placeholder">
            From
            <NewMailFullSizeFromPlaceholder v-if="!mailingList.length && !isHideMailingList" />
          </label>
          <div
            class="bbe-new-message-header-details-destination bbe-new-message-header-details-destination_from"
            @click="onOpenPopup"
          >
            <label
              v-if="mailFrom.mail"
              class="bbe-new-message-header-details-destination__item
                          bbe-new-message-header-details-destination__item_editable"
              :class="{'bbe-new-message-header-details-destination__item_disabled': disabledMassMailing}"
            >
              <span
                class="bbe-new-message-header-details-destination__content"
                @click="openSelectSendAs"
              >
                {{mailFrom.mail}}
                <i
                  v-if="!isHideMailingList"
                  class="email-icon-close bbe-new-message-header-details__remove"
                  @click="removeUser"
                />
              </span>
              <transition name="bbe-bounce">
                <ContactsList class="bbe-new-message-header-details-destination__contact-list"
                              v-if="displaySendAs"
                              :model="mailFrom.mail"
                              :list="sendAsEmails"
                              :select-mode="true"
                              modelName="from"
                              @setContact="setFrom"/>
              </transition>
            </label>
          </div>
        </div>
        <NewMailAddressInput placeholder="To"
                             :error="error"
                             :values="addressesTo"
                             model="addressesTo"
                             :copy-buttons="true"
                             :openCopy="openCopy"
                             :openCopyHidden="openCopyHidden"
                             @setModel="setAddresses"
                             @scrollUp="scrollUp"
                             @addCopy="addCopyInput"
                             @generateMessage="generateMessage"
                             />
          <NewMailAddressInput v-if="openCopy"
                               placeholder="Cc"
                               :error="error"
                               :values="addressesCc"
                               model="addressesCc"
                               :copy-buttons="false"
                               @setModel="setAddresses"
                               @scrollUp="scrollUp"
                               @generateMessage="generateMessage"
          />
          <NewMailAddressInput v-if="openCopyHidden"
                               placeholder="Bcc"
                               :isShowBcc="isShowBcc"
                               :error="error"
                               :values="addressesBcc"
                               model="addressesBcc"
                               :copy-buttons="false"
                               @setModel="setAddresses"
                               @scrollUp="scrollUp"
                               @generateMessage="generateMessage"
          />
        <label class="bbe-label">
          <input
            class="bbe-new-message-header-details__item bbe-input"
            :class="[isSubjectError && 'bbe-new-message-header-details__item_error']"
            type="text"
            @input="generateMessage"
            placeholder="Subject"
            v-model="mailSubject"
          >
          <transition name="bbe-fade">
            <span
              v-if="isSubjectError"
              class="bbe-error-text"
            >
              mandatory field
            </span>
          </transition>
        </label>
      </div>
      <div class="bbe-new-message-header__toolbar">
        <ToolbarTextEditor :quill="quill"
                           :formatting="activeStyle"
                           :selectDown="true"
                           @uploadFile="getFiles"/>
        <i class="email-icon-save bbe-new-message-header__save-template"
           v-click-outside="closeSaveOptions"
           @click.stop="openSaveOptions = !openSaveOptions">
          <PopupWithOptions class="bbe-new-message-header__save-template__popup"
                            :show="openSaveOptions"
                            :options="saveOptions"/>
        </i>
      </div>
    </div>
    <div
      class="bbe-new-message-body__wrapper"
      @click="setFocusToEditor" ref="bbeDropWrapper"
    >
      <VuePerfectScrollbar
        class="bbe-new-message-body"
        id="bbeEditorFull"
        @dragenter="setCursorFromDrag"
        @dragover="setCursorFromDrag"
        @click="setFocusToEditor"
      >
        <div
          class="bbe-new-message-body__message"
          id="editorFull"
        />
      </VuePerfectScrollbar>
      <DropFiles :visibility="visibilityDrop"/>
    </div>
    <div class="bbe-new-message__threads"
         :class="{'bbe-new-message__threads_reply': replyMsg}"
         ref="bbeScrollEmail"
         v-if="replyMsg"
    >
      <EmailMsg
        @setLoader="setLoader"
        @displayThreads="changeDisplayThreads"
        :replyMode="replyMsg"
      />
    </div>
    <div class="bbe-new-message-footer">
      <UploadFiles :files="uploadFiles" :dropped="dropFiles"/>
      <button class="bbe-button bbe-new-message-footer__send"
              :disabled="sendDisabled"
              @click="generateMessage({send: true})">
        {{sendButtonText}}
      </button>
    </div>
    <ModalWindow v-if="openModalSaveTemplate"
                 :title="titleSaveTemplate"
                 :right-button="saveTemplateButton"
                 @close="openModalSaveTemplate = false">
      <TemplateSaveFromMail @getName="getTemplateName" @getFolder="getFolder" :saveError="templateSaveError"/>
    </ModalWindow>
    <TemplateQuicklyAdd v-if="openTemplateSearch"
                        @close="closeQuicklyAdd"
                        :quill="quill"
                        :regexp="matchAll"
                        :keyword="wordTemplateSearch"
                        :position="templateSearchPosition"/>
    <BBESelectUsers
      v-if="isShowSelectUser"
      :usersList="mailingList"
      :activeUserId="activeUserId"
      :positionStyle="positionStyle"
      @setUser="setUser"
    />
    <transition name="bbe-fade">
      <BBEModalWindowInfo
        v-if="isShowModalInfo"
        :settings="settingsModal"
        @onClose="isShowModalInfo = false"
      />
    </transition>
  </VuePerfectScrollbar>
</template>

<script>
import ToolbarTextEditor from '@/components/Main/ToolbarTextEditor/ToolbarTextEditor'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {set, get, find, compact, uniq} from 'lodash'
import sendDraft from '@/mixin/sendDraft'
import {Jodit} from 'jodit'
import joditConfig from '@/constants/joditConfig'
import base64 from '@/mixin/base64'
import UploadFiles from '@/components/Main/UploadFiles/UploadFiles'
import validateEmail from '@/mixin/validateEmail'
import sendMessage from '@/mixin/sendMessage'
import signatureGenerator from '@/mixin/signatureGenerator'
import signatureGeneratorType2 from '@/mixin/signatureGeneratorType2'
import EmailMsg from '@/components/Email/EmailMsg/EmailMsg'
import DropFiles from '@/components/Main/DropFiles/DropFiles'
import initDropEvents from '@/mixin/initDropEvents'
import getFormatting from '@/mixin/getFormatting'
import UploadApi from '@/api/Upload/api'
import getBlobByUrl from '@/mixin/getBlobByUrl'
import ContactsList from '@/components/Main/FormsElements/ContactsList'
import TemplateSaveFromMail from '@/components/Templates/TemplateSaveFromMail/TemplateSaveFromMail'
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'
import b64toBlob from 'b64-to-blob'
import templatesApi from '@/api/Templates/api'
import {ROLES_LIST, FOUNDER} from '@/constants/roles'
import TemplateQuicklyAdd from '@/components/Templates/TemplateQuicklyAdd/TemplateQuicklyAdd'
import NewMailAddressInput from '@/components/NewMail/NewMailFullSize/NewMailAddressInput'
import PopupWithOptions from '@/components/Main/PopupWithOptions/PopupWithOptions'
import BBESelectUsers from '@/components/Main/BBESelectUsers/BBESelectUsers'
import GmailApi from '@/api/Gmail/api'
import MailingLogApi from '@/api/MailingLog/api'
import { OkIcon, UnOkIcon } from '@/constants/icons'
import BBEModalWindowInfo from '@/components/Main/ModalWindow/BBEModalWindowInfo'
import headerGmail from '@/mixin/headerGmail'
import NewMailFullSizeFromPlaceholder from '@/components/NewMail/NewMailFullSize/NewMailFullSizeFromPlaceholder'

export default {
  name: 'NewMailFullSize',
  components: {
    NewMailFullSizeFromPlaceholder,
    BBEModalWindowInfo,
    BBESelectUsers,
    PopupWithOptions,
    NewMailAddressInput,
    DropFiles,
    VuePerfectScrollbar,
    ToolbarTextEditor,
    LoaderFly,
    UploadFiles,
    EmailMsg,
    ContactsList,
    TemplateSaveFromMail,
    ModalWindow,
    TemplateQuicklyAdd
  },
  props: ['replyMsg', 'scrollParent'],
  mixins: [
    sendDraft,
    base64,
    validateEmail,
    sendMessage,
    signatureGenerator,
    signatureGeneratorType2,
    initDropEvents,
    getFormatting,
    getBlobByUrl,
    headerGmail
  ],
  data () {
    return {
      isShowSelectUser: false,
      mailingList: [],
      activeUserId: '',
      activeUserFull: {},
      positionStyle: {
        left: '86px',
        top: ' 45px'
      },
      sentMessages: 0,
      sendDisabled: false,
      editedAddress: -1,
      addressesOpen: false,
      regQuicklyAdd: /((\s|^|>))(@)(.*?)(?=<|$)/gmi,
      matchAll: [],
      openTemplateSearch: false,
      wordTemplateSearch: '',
      templateSearchPosition: {},
      templateSaveError: '',
      templateName: '',
      titleSaveTemplate: 'Save as Template',
      openModalSaveTemplate: false,
      openSaveOptions: false,
      saveOptions: [
        {title: 'Save as Template', action: this.openTemplateSave},
        {title: 'Save as Draft', action: this.saveDraft}
      ],
      filesIds: [],
      activeStyle: {},
      visibilityDrop: false,
      error: '',
      uploadFiles: [],
      dropFiles: [],
      lastTextChange: false,
      quill: '',
      loaderRun: false,
      mailSubject: '',
      mailFrom: {
        mail: '',
        name: ''
      },
      addressees: [],
      addressesTo: [],
      addressesCc: [],
      addressesBcc: [],
      openCopy: false,
      openCopyHidden: false,
      lastInputValue: '',
      addressesBodyHeight: 0,
      displaySendAs: false,
      templateParentId: '',
      isShowBcc: true,
      isMailingByClient: false,
      isSubjectError: false,
      isShowModalInfo: false,
      settingsModal: {}
    }
  },
  computed: {
    disabledMassMailing () {
      const userMassMailing = get(this.activeUser, 'massMailingCheck', '')
      return this.sendAsEmails.length < 2 || !userMassMailing
    },
    displayAccordionAddresses () {
      return this.addressesBodyHeight > 63
    },
    saveTemplateButton () {
      return {
        text: 'Save',
        action: this.saveAsTemplate
      }
    },
    sendButtonText () {
      return 'Send'
    },
    draggedTemplate () {
      return this.$store.getters.draggedTemplate
    },
    updateThreadStore: {
      get () {
        return this.$store.getters.updateThreadStore
      },
      set (data) {
        this.$store.dispatch('setUpdateThreadStore', data)
      }
    },
    newMessage: {
      get: function () {
        return this.$store.getters.newMessage
      },
      set: function (data) {
        this.$store.dispatch('setNewMessage', data)
      }
    },
    activeUser () {
      return this.$store.getters.userInfo || this.$store.getters.activeUser
    },
    activeEmail: {
      get: function () {
        return this.$store.getters.activeEmail
      },
      set: function (data) {
        this.$store.dispatch('setActiveEmail', data)
      }
    },
    activeTab () {
      return this.$store.getters.activeTab
    },
    draftEmail: {
      get () {
        return this.$store.getters.draftEmail
      },
      set (data) {
        this.$store.dispatch('setDraftEmail', data)
      }
    },
    templatesList: {
      get: function () {
        return this.$store.getters.templatesList
      },
      set: function (data) {
        this.$store.dispatch('setTemplatesList', data)
      }
    },
    massMailing: {
      get: function () {
        return this.$store.getters.emailStore
      },
      set: function (data) {
        this.$store.dispatch('setEmailStore', data)
      }
    },
    sendAsEmails: {
      get: function () {
        return this.$store.getters.sendAsEmails
      },
      set: function (data) {
        this.$store.dispatch('setSendAsEmails', data)
      }
    },
    isHideMailingList () {
      const { isHideMailingList = false } = this.newMessage
      return isHideMailingList
    },
    isFounder () {
      const { role } = this.activeUser
      return role === FOUNDER.id
    }
  },
  methods: {
    onOpenPopup () {
      if (!this.isFounder) return
      if (!this.mailingList.length || this.activeUserId) return
      this.isShowSelectUser = !this.isShowSelectUser
    },
    removeUser () {
      this.isShowSelectUser = false
      this.defaultSettings()
    },
    defaultSettings () {
      this.activeUserId = ''
      this.mailFrom.mail = ''
      this.quill.value = ''
    },
    setUser (user) {
      const { username, _id } = user
      this.mailFrom.mail = username
      this.activeUserId = _id
      this.activeUserFull = user
      this.isShowSelectUser = !this.isShowSelectUser
      this.setMessage()
    },
    async gmailMailing () {
      try {
        const { data } = await GmailApi.gmailMailing()
        this.mailingList = data

        const { image = {}, role } = this.activeUser
        if (role === FOUNDER.id) {
          const founder = {
            ...this.activeUser,
            image: get(image, 'path', '')
          }
          this.mailingList.push(founder)
        }
        this.buttonDisabled()
      } catch (err) {
        console.error(err)
      }
    },
    setAddresses ({state, addressees}) {
      this[state] = addressees
    },
    scrollUp () {
      const scroll = get(this.$refs, 'bbeNewMailScroll.$el', {})
      scroll.scrollTop = 0
    },
    addCopyInput (copyType) {
      this[copyType] = true
    },
    toggleAccordionAddresses () {
      this.addressesOpen = !this.addressesOpen
      this.$nextTick(this.setBodyAddressesHeight)
    },
    setBodyAddressesHeight () {
      const elBlock = this.$refs.bbeAddressesElements
      if (!elBlock) return
      const manyAddresses = this.addressees.length > 250
      const timeout = manyAddresses ? 0 : 400
      elBlock.style.transition = manyAddresses ? 'none' : `${timeout}ms linear`
      if (this.addressesOpen) {
        elBlock.style.maxHeight = `${elBlock.scrollHeight + 1000}px`
      } else {
        elBlock.style.maxHeight = '63px'
        const scrollHeight = elBlock.scrollHeight
        setTimeout(() => {
          const inputBlock = this.$refs.bbeNewAddressesInput
          if (inputBlock) inputBlock.focus()
          elBlock.scrollTop = scrollHeight
        }, timeout + 50)
      }
    },
    uploadFile (file, img) {
      const blob = b64toBlob(file.data64, file.mimeType)
      const fileData = new FormData()
      fileData.set('label', file.id)
      fileData.set('file', blob)
      fileData.set('fieldname', 'uploadFile')
      UploadApi.uploadFile(fileData)
        .then(resp => {
          img.src = resp.data.path
        })
        .catch((err) => {
          console.error(err)
        })
    },
    closeSaveOptions () {
      this.openSaveOptions = false
    },
    getFiles (filesIds) {
      this.filesIds = filesIds
    },
    openTemplateSave () {
      this.openModalSaveTemplate = true
    },
    async saveDraft () {
      const addressees = {
        to: [compact(uniq(this.addressesTo))],
        cc: [compact(uniq(this.addressesCc))],
        bcc: [compact(uniq(this.addressesBcc))]
      }
      const mails = this.getMail({addressees, index: 0})
      mails.isDraft = true
      const mimeMessage = await this.createMimeMessage(mails)
      const draft = await this.sendDraft({
        draftThreadId: get(this.newMessage, 'draftThreadId', ''),
        userId: mails.userId,
        mail: mimeMessage.content
      })
      const draftThreadId = get(draft, 'message.threadId', '')
      this.updateThreadStore = draftThreadId
      set(this.newMessage, 'draftThreadId', draftThreadId)
    },
    checkedUploadFiles () {
      this.filesIds.forEach((id, index) => {
        const img = document.getElementById(id)
        if (!img) this.deleteFile(id, index)
      })
    },
    deleteFile (id, index) {
      UploadApi.deleteFile(id)
        .then(resp => {
          this.filesIds.splice(index, 1)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getTemplateName (name) {
      this.templateName = name
    },
    getFolder (folder) {
      this.templateParentId = get(folder, 'id', '')
    },
    saveAsTemplate () {
      const template = {
        name: this.templateName,
        dateCreateFolder: new Date(),
        content: this.quill.value,
        roles: ROLES_LIST.map(item => item.id)
      }
      if (!this.templateName) {
        this.templateSaveError = 'Template name is field is required'
        return
      }
      this.templateSaveError = ''
      if (this.templateParentId) template.parentFolder = this.templateParentId
      templatesApi.createTemplate(template)
        .then(resp => {
          this.openModalSaveTemplate = false
          this.templatesList.push({...resp.data, fromMail: true})
        })
        .catch(err => {
          this.templateSaveError = err.response.data.status
          console.error(err)
        })
    },
    initDrop () {
      this.draggedTemplate.uploadFiles = []
      const target = this.$refs.bbeDropWrapper
      this.initDropEvents({
        target: target,
        drop: this.handleDrop,
        dragEnter: () => {
          this.visibilityDrop = true
        },
        dragLeave: () => {
          this.visibilityDrop = false
        }
      })
    },
    handleDrop (e) {
      const dt = e.dataTransfer
      const files = dt.files
      this.dropFiles = [...files]
    },
    setFocusToEditor () {
      this.quill.selection.focus()
    },
    setLoader (data) {
      this.loaderRun = data
    },
    changeDisplayThreads (value) {
      const scrollElement = get(this.scrollParent, '$el', {})
      const scrollParams = {
        top: 0,
        behavior: 'smooth'
      }
      value ? scrollParams.top = scrollElement.scrollTop + 78 : scrollParams.top = 0
      this.$nextTick(() => {
        scrollElement.scrollTo(scrollParams)
      })
    },
    openPopupMessage () {
      this.newMessage.openFullSize = false
      this.$set(this.newMessage, 'open', true)
    },
    getMail ({addressees, index}) {
      const userIdFromModel = get(this.mailFrom, 'mail', '')
      const usernameFromModel = get(this.mailFrom, 'name', '')
      const replyTo = get(this.activeUser, 'gmail.email', 'me')
      const userId = userIdFromModel || replyTo
      const username = usernameFromModel || get(this.activeUser, 'gmail.name', 'me')
      const contentHtml = this.quill.value
      const toEmail = get(addressees, ['to', index], []).join(', ')
      const copy = get(addressees, ['cc', index], []).join(', ')
      const copyHide = get(addressees, ['bcc', index], []).join(', ')
      const toName = get(this.activeEmail, 'from.name', '')
      const subject = this.mailSubject
      const msg = get(this.activeEmail.messages, 0, {})
      const messageId = get(msg, 'id', '')
      const msgHeaders = get(msg, 'payload.headers', [])
      const msgIdObject = find(msgHeaders, {name: 'Message-ID'}) || find(msgHeaders, {name: 'Message-Id'})
      const msgId = get(msgIdObject, 'value', '')
      return {
        messageId,
        userId,
        username,
        copyHide,
        replyTo,
        attachments: this.uploadFiles,
        msgId: this.replyMsg ? msgId : '',
        toEmail: toEmail,
        toName: this.replyMsg ? toName : '',
        subject: subject,
        contentHtml: contentHtml,
        copy: copy
      }
    },
    openSelectSendAs () {
      if (this.disabledMassMailing) return
      this.displaySendAs = !this.displaySendAs
    },
    setFrom (address) {
      this.displaySendAs = false
      const email = get(address, 'sendAsEmail', '')
      const displayName = get(address, 'displayName', '')
      this.mailFrom = {name: displayName, mail: email}
    },
    generateMessage ({send}) {
      if (this.sendDisabled) return
      this.error = ''
      this.checkedUploadFiles()
      this.lastTextChange = Date.now()
      if (!send) return
      if (this.massMailing.length) {
        this.distributionMailing()
      } else {
        this.emailSend()
      }
    },
    makeBody (params) {
      const { to, inTo, references, subject, content } = params
      // eslint-disable-next-line new-cap
      params.subject = new Buffer.from(subject).toString('base64')
      const str = [
        'Content-Type: text/html; charset=\'UTF-8\'\r\n' +
        'MINE-Version: 1.0\n',
        'Content-Transfer-Encoding: 7bit\n',
        `To: ${to} \n`,
        `In-Reply-To: ${inTo} \n`,
        `References: ${references} \n`,
        `Subject: =?UTF-8?B?${subject}?= \n\n`,
        '<html><body>' +
        content +
        '</body></html>'
      ].join('') // <--- Modified

      // eslint-disable-next-line new-cap
      return new Buffer.from(str)
        .toString('base64')
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
    },
    createReferencesAndInTo (messages = []) {
      const lastMessage = messages[messages.length - 1]
      const { payload = {}, id, threadId } = lastMessage
      const { headers = [] } = payload
      const messagesId = headers.find((el) => el.name === 'Message-ID' || el.name === 'Message-Id')
      const references = headers.find((el) => el.name === 'References')
      return {
        inTo: messagesId.value,
        references: references ? references.value : messagesId.value,
        id,
        threadId
      }
    },
    createBodyEmailSend () {
      const { value } = this.quill
      const { subject, messages } = this.activeEmail
      const { inTo, references, threadId, id } = this.createReferencesAndInTo(messages)
      const { isForward = false } = this.newMessage
      const raw = this.makeBody({
        to: this.addressesTo.join(','),
        from: 'me',
        references,
        inTo,
        subject: `${isForward ? 'Fwd' : 'Re'}:${subject}`,
        content: value
      })

      const body = {
        raw,
        id,
        threadId
      }
      return body
    },
    async emailSend () {
      this.loaderRun = true
      const header = this.headerGmail()
      const body = this.createBodyEmailSend()
      try {
        await GmailApi.emailSend(header, body)
        this.loaderRun = false
        this.newMessage = {
          openFullSize: false,
          status: 'sent'
        }
        this.activeEmail = {}
        setTimeout(() => {
          this.newMessage.status = ''
        }, 3000)
      } catch (err) {
        this.loaderRun = false
        console.error(err)
      }
    },
    getFullTime(milliseconds) {
      let minutes =  Math.ceil(milliseconds / 60000);

      const hours = Math.floor(minutes / 60);

      if (hours) {
        minutes = minutes - hours * 60;
      }

      return !!hours
        ? `${hours} hours ${minutes} minutes`
        : `${minutes} minutes`;
    },
    async getMailingLogById (email, fullTimeCurrent) {
      try {
        const { data } = await MailingLogApi.getMailingLogById({email});

        if (!data.length) return false;

        const [last] = data.sort(function(a,b){
          return new Date(b.createdAt) - new Date(a.createdAt);
        });

        const { isOpen, dateEnd, presumablyDateEnd } = last || {};

        if (isOpen) {

          const orderTime = new Date(presumablyDateEnd).getTime() - new Date(new Date().toISOString()).getTime();
          const fullTime = this.getFullTime(orderTime)

          this.createContentModal({
            title: 'The newsletter has been created',
            description:
              `Your mailing list in ${data.length +1 } queues and will take approximately ${fullTimeCurrent}`,
            description2: `Your current mailing list will start in ${fullTime}`,
            icon: OkIcon
          })

          this.isShowModalInfo = true
        } else {
          const ms = new Date() - new Date(dateEnd)
          const minutes = Math.ceil(ms / 60000)
          this.createContentModal({
            title: 'Error sending emails',
            description: 'Use an interval of 5 minutes between mailings.',
            description2: `Try sending the newsletter in ${5 - minutes} min or use a different email sender.`,
            icon: UnOkIcon,
            color: 'red'
          })

          if (minutes < 5) {
            this.isShowModalInfo = true
            return true
          }
        }
        return true;
      } catch (err) {
        console.error(err)
        return false
      }
    },
    createBody (email) {
      const body = {
        to: this.addressesTo,
        cc: this.addressesCc,
        bcc: this.addressesBcc,
        html: this.quill.value,
        email,
        subject: this.mailSubject
      }
      return body
    },
    async distributionMailing () {
      if (!this.mailSubject) {
        this.isSubjectError = true
        this.sendDisabled = true
        return
      }
      const { email } = this.activeUserFull
      const body = this.createBody(email)

      const {to, cc, bcc } = body;

      const finishedCurrentMailing = (to.length + bcc.length + cc.length) * 10000 + 1000;

      const fullTimeCurrent = this.getFullTime(finishedCurrentMailing);
      const isQueue = await this.getMailingLogById(email, fullTimeCurrent)

      try {
        await GmailApi.distributionMailing(body)

        if (!isQueue) {
          this.createContentModal({
            title: 'The newsletter has been created',
            description: `Your mailing list is the first in order and will take approximately ${fullTimeCurrent}`,
            icon: OkIcon
          })
        }

        this.afterDistributionMailing()
      } catch (err) {
        console.error(err)
        this.createContentModal({
          title: 'Error sending emails',
          description: 'The token\'s lifetime has expired. Reconnect the sender\'s mail in the settings',
          icon: UnOkIcon,
          color: 'red'
        })
        this.afterDistributionMailing()
      }
    },
    afterDistributionMailing () {
      this.defaultSettings()
      this.mailSubject = ''
      this.isShowModalInfo = true
      this.addressesTo = []
      this.addressesCc = []
      this.addressesBcc = []
    },
    createContentModal ({title, description, description2, icon, color}) {
      this.settingsModal = {
        title,
        description,
        description2,
        icon,
        color
      }
    },
    setAttachmentsInset () {
      if (!this.newMessage.attachmentsInset) return
      this.newMessage.attachmentsInset.forEach(file => {
        const image = document.querySelector(`IMG[src="cid:${file.id}"]`)
        const src = `data:${file.mimeType};base64,${file.data64}`
        if (!image) return
        image.src = src
        this.uploadFile(file, image)
      })
    },
    setMessage () {
      this.mailSubject = get(this.newMessage, 'subject', '')
      if (this.addressesCc.length) this.openCopy = true
      if (this.addressesBcc.length) this.openCopyHidden = true
      this.uploadFiles = this.newMessage.files || []
      this.quill.value = ''
      if (this.newMessage.contents && !this.replyMsg) {
        this.setSignature()
        this.setAttachmentsInset()
      } else if (this.replyMsg) {
        this.setSignature()
      }
      const coordinate = this.quill.workplace.getBoundingClientRect()
      if (coordinate) {
        this.quill.selection.insertCursorAtPoint(coordinate.left, coordinate.top)
      }
      this.setSignature()
      this.addressesBodyHeight = get(this.$refs, 'bbeAddressesBody.offsetHeight', 0)
    },
    params () {
      const params = {
        photo: get(this.activeUserFull, 'image', ''),
        username: get(this.activeUserFull, 'username', ''),
        position: get(this.activeUserFull, 'position.name', ''),
        phone: get(this.activeUserFull, 'phone', ''),
        email: get(this.activeUserFull, 'email', '')
      }
      return params
    },
    createContentHtml () {
      const param = this.params()
      const { signatureType = 1 } = this.currentCompany
      const content = signatureType === 1 ? this.generateSignature(param) : this.generateSignatureType2(param)
      return content
    },
    setSignature () {
      const { contents, isForward = false } = this.newMessage
      const content = this.createContentHtml()
      this.newMessage.contents = isForward ? contents + content : content
      this.quill.value = ''
      this.quill.selection.insertHTML(this.newMessage.contents)
    },
    setCursorFromDrag (e) {
      this.quill.selection.insertCursorAtPoint(e.pageX, e.pageY)
    },
    getStyles (e) {
      if (e) {
        this.activeStyle = this.getFormatting(e.path)
      }
    },
    setUploadFiles (files = []) {
      files.forEach(file => {
        if (file.base64) {
          file.uploaded = true
          this.uploadFiles.push(file)
          return
        }
        if (!file.path) return
        this.getBlobByUrl(file.path)
          .then(resp => {
            const reader = new FileReader()
            reader.readAsDataURL(resp.data)
            reader.onload = () => {
              file.name = file.label || file.name
              file.type = resp.data.type
              file.size = resp.data.size
              file.status = true
              file.uploaded = true
              file.base64 = reader.result
              this.uploadFiles.push(file)
            }
          })
          .catch((err) => {
            console.error(err)
          })
      })
      this.draggedTemplate.uploadFiles = []
    },
    getClientRects () {
      const textNode = this.quill.selection.current()
      const range = document.createRange()
      try {
        range.selectNodeContents(textNode)
        const rects = range.getClientRects() || []
        return rects[0]
      } catch (e) {
        return ''
      }
    },
    quicklyTemplate () {
      this.regQuicklyAdd.lastIndex = 0
      this.matchAll = [...this.quill.value.matchAll(this.regQuicklyAdd)][0] || []
      this.openTemplateSearch = this.matchAll[3] === '@'
      this.wordTemplateSearch = this.matchAll[4]
      if (this.openTemplateSearch && this.wordTemplateSearch) {
        this.templateSearchPosition = this.getClientRects()
      }
    },
    closeQuicklyAdd () {
      this.quill.editor.setAttribute('contenteditable', true)
      this.openTemplateSearch = false
      this.regQuicklyAdd.lastIndex = 0
    },
    checkedMassMailing () {
      const lengthAddressees = get(this.massMailing, 'length', 0)
      if (lengthAddressees > 0) {
        this.openCopyHidden = true
        const emails = this.massMailing.map(item => {
          return get(item, 'email', [])
        })
        const emailsFlat = emails.flat()
        this.addressesBcc = uniq(compact(emailsFlat))
      }
    },
    buttonDisabled () {
      this.sendDisabled = !this.activeUserId || !this.mailingList.length
    },
    scrollTop () {
      const element = document.getElementsByClassName('bb-right-panel')
      const [elem = {}] = element
      elem.scrollTop = 0
    },
    setFullUser () {
      const { image } = this.activeUser
      const imageUser = get(image, 'path', '')
      this.activeUserFull = {
        ...this.activeUser,
        image: imageUser
      }
    },
    setMailFrom () {
      const { username = '' } = this.activeUser
      this.mailFrom = {
        mail: username
      }
      const { toEmail = [], copy = [] } = this.newMessage
      this.addressesTo = toEmail
      this.addressesCc = copy
      this.sendDisabled = false
      this.setFullUser()
      this.setMessage()
    }
  },
  watch: {
    mailSubject () {
      if (this.isHideMailingList) return
      this.isSubjectError = false
      this.sendDisabled = !this.activeUserId || !this.mailingList.length
    },
    newMessage (newVal, oldVal) {
      if (newVal !== oldVal) this.setMessage()
    },
    activeUserId (newVal) {
      this.sendDisabled = !newVal
    }
  },
  mounted () {
    this.initDrop()
    joditConfig.editorCssClass = 'bbe-new-message-body__message'
    joditConfig.editorCssClass = 'bbetexteditor'
    this.quill = new Jodit('#editorFull', joditConfig)
    this.quill.events.on('change', () => {
      this.quicklyTemplate()
      this.generateMessage({})
    })
    this.quill.events.on('click', (e) => {
      this.getStyles(e)
    })
    this.quill.events.on('afterInsertNode', () => {
      this.visibilityDrop = false
      this.$set(this.draggedTemplate, 'start', false)
      if (this.draggedTemplate.callback) {
        this.draggedTemplate.callback()
      }
      this.setUploadFiles(this.draggedTemplate.uploadFiles)
    })
    // this.$nextTick(() => {
    //   this.setMessage()
    // })
  },
  beforeMount () {
    if (!this.isHideMailingList) this.gmailMailing()
    this.checkedMassMailing()
    this.$nextTick(() => {
      this.isShowSelectUser = false
      this.defaultSettings()
      this.scrollTop()
      if (this.isHideMailingList) this.setMailFrom()
    })
  },
  beforeDestroy () {
    this.massMailing = []
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbe-new-message {
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 100%;
    height: calc(100vh - 66px);

    &-header {
      position: relative;

      &__resize {
        position: absolute;
        top: 8px;
        right: 8px;
        display: none; // flex
        justify-content: center;
        align-items: center;
        width: 32px;
        height: 32px;
        font-size: 14px;
        color: $color-silver-chalice;
        z-index: 2;
        cursor: pointer;

        &:hover {
          color: $color-dusty-gray;
          background-color: $color-gallery;
          border-radius: 4px;
        }
      }

      &-details {
        padding: 0 30px;
        transition: .3s;
        margin-top: 12px;

        &__remove {
          margin: 0 0 0 5px;
          padding: 2px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 10px;
          line-height: 1;
          opacity: 0.4;
          cursor: pointer;
          transition: 0.3s ease-in-out;

          &:hover {
            color: $color-accent-hover;
            opacity: 0.8;
          }

          &:before {
            margin: 0;
          }
        }

        &-label {
          border-bottom: 1px solid $color-gallery;

          &-accordion {
            position: absolute;
            top: 4px;
            right: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 500;
            font-size: 12px;
            line-height: 14px;
            color: $color-accent;
            cursor: pointer;
            transition: 0.3s;
            z-index: 1;

            &_active &__icon {
              &:before {
                transform: rotate(0deg);
              }
            }

            &:hover {
              color: $color-accent-hover;
            }

            &__icon {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 26px;
              height: 22px;
              font-size: 8px;
              border-radius: 122px;
              background-color: $color-link-water;
              margin-left: 4px;

              &:before {
                transition: 0.3s;
                transform: rotate(180deg);
                width: 14px;
                margin: 0;
              }
            }
          }
        }

        &-destination {
          position: relative;
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          border-radius: 0;
          margin-top: 6px;
          font-size: 14px;
          line-height: 17px;
          max-height: 63px;
          transition: 0.4s;
          overflow: hidden;

          &_from {
            height: 30px;
            overflow: visible;
          }

          &__placeholder {
            display: flex;
            align-items: center;
            justify-content: space-between;
            align-self: flex-start;
            color: $color-silver-chalice;
            font-weight: 500;
            font-size: 13px;
            margin-top: 10px;
            width: 59px;
            min-width: 59px;
            height: 100%;
            user-select: none;
          }

          &_error {
            border-bottom: 1px solid $color-pomegranate;
          }

          &__item {
            display: inline-grid;
            width: auto;
            grid-template-columns: auto 14px;
            grid-gap: 4px;
            align-items: center;
            justify-content: center;
            padding: 4px 8px;
            background-color: $color-link-water;
            color: $color-accent;
            font-weight: 500;
            font-size: 12px;
            line-height: 1;
            border-radius: 122px;
            margin-right: 8px;
            margin-bottom: 8px;
            white-space: nowrap;
            cursor: pointer;
            transition: 0.3s;
            user-select: none;

            &:hover {
              color: $color-accent-hover;
            }

            &_editable {
              grid-template-columns: auto;
            }

            &_disabled {
              user-select: none;
              cursor: default;
            }
          }

          &__content {
            display: flex;
            align-items: center;
            padding: 0;
            font-weight: 500;
            font-size: 12px;
            line-height: 1;
            border: none;
            background-color: transparent;
            transition: 0.3s;
            text-transform: capitalize;

            &_hide {
              position: absolute;
              opacity: 0;
              z-index: -1;
            }
          }

          &__input {
            position: relative;
            flex-grow: 1;
            width: auto;
            margin-bottom: 8px;
            min-height: 22px;
          }

          &__remove {
            padding: 2px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 10px;
            line-height: 1;
            opacity: 0.4;
            cursor: pointer;
            transition: 0.3s;

            &:hover {
              color: $color-accent-hover;
              opacity: 0.8;
            }

            &:before {
              margin: 0;
            }
          }
        }

        &__item {
          border-radius: 0;
          padding: 8px 0;
          margin-top: 6px;
          border-bottom: 1px solid $color-gallery;

          &_error {
            border-bottom: 1px solid $color-pomegranate;
          }
        }

        &__copy {
          align-self: flex-end;
          height: 100%;
          font-size: 13px;
          color: $color-silver-chalice;
          padding: 8px 10px 8px 0;
          margin-top: 6px;
          cursor: pointer;

          &:hover {
            text-decoration: underline;
          }

          &:last-child {
            margin-right: 5px;
          }
        }

        &__error {
          top: 2px;
          right: 65px;
        }
      }

      &__toolbar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 42px;
        margin: 11px 22px 11px 0;
      }

      &__save-template {
        position: relative;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $color-accent;
        cursor: pointer;
        transition: .1s;
        width: 26px;
        height: 26px;
        border: 1px solid $color-gallery;
        box-sizing: border-box;
        border-radius: 4px;

        &:hover {
          color: $color-accent-hover;
        }

        &__popup {
          top: 30px;
          right: 0;
          z-index: 2;
        }
      }
    }

    &__threads {
      height: 100%;
      max-height: 100%;
      padding: 0 30px;

      &_reply {
        height: 60%;
        padding: 0;
      }
    }

    &-body {
      position: relative;
      height: 100%;
      padding: 5px 10px 5px 5px;

      &__wrapper {
        position: relative;
        margin: 0 20px 0 30px;
        display: flex;
        flex-grow: 1;
        flex-direction: column;
        height: 100%;
        //max-height: calc(100vh - 500px);
        min-height: 400px;
      }

      &__message {
        height: 100%;
        cursor: text;
        position: relative;
      }
    }

    &-footer {
      position: sticky;
      bottom: 0;
      background: $color-white;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 19px 30px 19px;
      transition: .3s;
      min-height: 80px;
      z-index: 1;
      margin-top: auto;
      margin-bottom: 0;

      &:after {
        @include line-after-top;
        left: 0;
        right: 0;
        width: 100%;
        top: 0;
      }

      &__send {
        margin-left: 14px;
      }

      &__reply-icon {
        font-size: 14px;
        margin-right: 7px;
      }
    }
  }

</style>

<style lang="scss">
@import "../../../sass/variables";

  .bbe-new-message-body {
    .jodit_container {
      height: 100%;

      .jodit_workplace {
        height: 100%;

        .jodit_wysiwyg {
          height: 100%;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/NewMail/NewMailFullSize/NewMailFullSize.vue